// extracted by mini-css-extract-plugin
export default {"container":"MainPage_container__Lm-lH","wrapper":"MainPage_wrapper__JFbZh","item":"MainPage_item__mjuGP","title":"MainPage_title__goIOM","table":"MainPage_table__2Xt-S"};